<section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03] mb-6">
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'analytics.title' | t }}</h3>
      <p class="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{{ 'analytics.owner.subtitle' | t }}</p>
    </div>
    <div class="w-full sm:w-44">
      <app-pretty-select
        [options]="periodOptions"
        [ngModel]="period()"
        (ngModelChange)="changePeriod($event)"
      />
    </div>
  </div>

  @if (loading()) {
    <div class="flex h-[220px] items-center justify-center text-sm text-gray-400 dark:text-gray-500">
      {{ 'analytics.loading' | t }}
    </div>
  } @else if (unresolved()) {
    <!-- 403 : acteur non résolvable (backfill non passé) — message dédié. -->
    <div class="mt-4 flex items-start gap-3 rounded-xl border border-blue-light-200 bg-blue-light-50 p-4 dark:border-blue-light-500/30 dark:bg-blue-light-500/10">
      <svg class="mt-0.5 shrink-0 text-blue-light-500" width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 8h.01M11 12h1v4h1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
      <p class="text-sm text-blue-light-700 dark:text-blue-light-200">{{ 'analytics.unresolved' | t }}</p>
    </div>
  } @else if (error()) {
    <div class="mt-4 flex items-center justify-between gap-3 rounded-xl border border-error-200 bg-error-50 p-4 dark:border-error-500/30 dark:bg-error-500/10">
      <p class="text-sm text-error-700 dark:text-error-400">{{ error() }}</p>
      <button type="button" (click)="load()" class="shrink-0 text-xs font-medium text-error-700 hover:underline dark:text-error-400">{{ 'common.retry' | t }}</button>
    </div>
  } @else if (settlement(); as s) {
    <!-- KPIs -->
    <div class="mt-5 grid grid-cols-2 gap-4 lg:grid-cols-4">
      <div class="rounded-xl border border-gray-100 p-4 dark:border-gray-800">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ 'analytics.kpi.grossRevenue' | t }}</span>
        <p class="mt-1 text-xl font-bold text-gray-800 dark:text-white/90">{{ s.grossAmount | number: '1.0-0' }} <span class="text-xs font-normal text-gray-400">XOF</span></p>
      </div>
      <div class="rounded-xl border border-gray-100 p-4 dark:border-gray-800">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ 'analytics.kpi.netEstimate' | t }}</span>
        <p class="mt-1 text-xl font-bold text-brand-700 dark:text-brand-400">{{ netAmount() | number: '1.0-0' }} <span class="text-xs font-normal text-gray-400">XOF</span></p>
      </div>
      <div class="rounded-xl border border-gray-100 p-4 dark:border-gray-800">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ 'analytics.kpi.platformCommission' | t }}</span>
        <p class="mt-1 text-xl font-bold text-gray-800 dark:text-white/90">{{ s.platformAmount | number: '1.0-0' }} <span class="text-xs font-normal text-gray-400">XOF</span></p>
      </div>
      <div class="rounded-xl border border-gray-100 p-4 dark:border-gray-800">
        <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ 'analytics.kpi.avgRating' | t }}</span>
        <p class="mt-1 text-xl font-bold text-gray-800 dark:text-white/90">
          {{ ratingLabel() }}
          @if (rating()?.ratingCount) {
            <span class="text-xs font-normal text-gray-400">/ 5 · {{ rating()?.ratingCount }}</span>
          }
        </p>
      </div>
    </div>

    <!-- Courbe + donut -->
    <div class="mt-6 grid gap-6 lg:grid-cols-3">
      <div class="lg:col-span-2">
        <h4 class="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'analytics.chart.revenue' | t }}</h4>
        <app-analytics-series-chart
          [points]="series()"
          [seriesName]="seriesName()"
          [emptyLabel]="'analytics.empty' | t"
        />
      </div>
      <div>
        <h4 class="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'analytics.donut.byMode' | t }}</h4>
        <app-analytics-donut
          [items]="s.byPaymentMode"
          keyPrefix="label.paymentMode"
          [emptyLabel]="'analytics.empty' | t"
        />
      </div>
    </div>
  }
</section>
